import * as yup from 'yup'

export interface DeclarationOfOwnershipSignerInfoDto {
  declarationOfOwnershipSignerSignatureFileName?: string
  declarationOfOwnershipSignerSignatureFile?: File
}

export const DeclarationOfOwnershipSignerInit: DeclarationOfOwnershipSignerInfoDto = {
  declarationOfOwnershipSignerSignatureFileName: undefined,
  declarationOfOwnershipSignerSignatureFile: undefined
}

export const DeclarationOfOwnershipSignerInfoValidator = yup.object({
  declarationOfOwnershipSignerSignatureFile: yup
    .mixed()
    // @ts-ignore
    .test('Signature is required.', (value: File) => value)
    .required('Signature is required.')
})
